import React, { useEffect, useState } from "react";
// import doc from '../../../assets/images/img-icons/doc.png';
// import excel from '../../../assets/images/img-icons/excel.png';
// import pdf from '../../../assets/images/img-icons/pdf.png';
import PageTitle from "./../../../components/partials/PageTitle";
import StaffTable from "./../../../components/tables/admin/StaffTable";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getAllStaffs,
  // getStaffInformation,
} from "../../../redux/slice/staff/staffSlice";

const ListOfStaff = () => {
  const [hasCreateStaff, setHasCreateStaff] = useState();
  const [filterBy, setFilterBy] = useState();

  const { user_permissions } = useSelector((state) => state.auth?.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const breadcrumb = {
    from: {
      title: "Staff",
      link: "/admin/staff",
    },
    current: {
      title: "staff list",
      link: null,
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(getAllStaffs({ pageNumber: 1, search: filterBy }));
  };

  useEffect(() => {
    if (!filterBy) {
      dispatch(getAllStaffs({ pageNumber: 1, search: filterBy }));
    }
  }, [dispatch, filterBy])
  

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasCreateStaff(
      user_permissions?.some((permission) => permission.name === "create staff")
    );
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff List' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Staff List Table
                  </h4>
                  {hasCreateStaff && (
                    <div className='d-flex items- float-end borde'>
                      <form
                        onSubmit={handleSubmit}
                        className='d-flex bg-primary-1 align-items-center me-2'
                        style={{ height: "30px", width: "217px" }}
                      >
                        <input
                          type='search'
                          value={filterBy}
                          className='border-0'
                          placeholder='Search...'
                          onChange={(e) => setFilterBy(e.target.value)}
                          style={{
                            height: "28px",
                            marginLeft: "1px",
                            paddingLeft: "5px",
                            outline: "none",
                          }}
                        />
                        <button
                          type='submit'
                          className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                          style={{ height: "28px" }}
                        >
                          <i className='uil uil-search text-white fs-4'></i>
                        </button>
                      </form>
                      <Link
                        to='/admin/add-staff'
                        className='btn btn-sm btn-primary'
                      >
                        <i className='uil-user-plus mr-2'></i>
                        <span className='ms-1 border-0'>Add New Staff</span>
                      </Link>
                      {/* <span className='bg-info p-1  me-2 text-white'>Export to</span>
                                                <a href="#"><img src={excel} alt="" /></a>
                                                <a href="#" className='mx-2'><img src={pdf} alt="" /></a>
                                                <a href="#"><img src={doc} alt="" /></a> */}
                    </div>
                  )}
                </div>
              </div>
              <StaffTable />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfStaff;
